import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { doc, updateDoc, getDoc } from 'firebase/firestore';
import { db } from '../../../services/firebase';
import { useTenant } from '../../../hooks/useTenant';
import { toast } from 'react-toastify';
import { NeoLoader } from '../../../components/Common';

import bgRunning from '../../../assets/images/kiosk_bgs/bg_running_1777982795262.png';
import bgWeightlifting from '../../../assets/images/kiosk_bgs/bg_weightlifting_1777982840440.png';
import bgCrossfit from '../../../assets/images/kiosk_bgs/bg_crossfit_1777982887027.png';
import bgSwimming from '../../../assets/images/new1Bg.png'; // Using the existing one

export const BACKGROUND_OPTIONS = [
    { id: 'swimming', label: 'Natação / Geral', src: bgSwimming },
    { id: 'running', label: 'Corrida', src: bgRunning },
    { id: 'weightlifting', label: 'Musculação', src: bgWeightlifting },
    { id: 'crossfit', label: 'Crossfit', src: bgCrossfit },
];

/**
 * MediaBackgrounds
 * Componente para seleção de plano de fundo do Totem de autoatendimento.
 */
const MediaBackgrounds = () => {
    const { idTenant } = useTenant();
    const [selectedBg, setSelectedBg] = useState('swimming');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!idTenant) return;
        getDoc(doc(db, 'tenants', idTenant)).then(snap => {
            if (snap.exists() && snap.data().kioskBackground) {
                setSelectedBg(snap.data().kioskBackground);
            }
            setIsLoading(false);
        });
    }, [idTenant]);

    const handleSelectBg = async (bgId) => {
        setSelectedBg(bgId);
        try {
            await updateDoc(doc(db, 'tenants', idTenant), { kioskBackground: bgId });
            toast.success("Plano de fundo atualizado!");
        } catch (error) {
            toast.error("Erro ao atualizar o fundo.");
        }
    };

    if (isLoading) {
        return (
            <div className="py-5">
                <NeoLoader type="spinner" label="Carregando planos de fundo..." />
            </div>
        );
    }

    return (
        <div className="p-4 m-3 bg-light bg-opacity-40 rounded-3" style={{ border: "1.5px solid rgba(72, 39, 18, 0.08)" }}>
            <h5 className="mb-1 fw-bold text-dark font-size-15" style={{ fontFamily: "Outfit" }}>Plano de Fundo do Totem</h5>
            <p className="mb-4 text-muted small font-size-12" style={{ fontFamily: "Outfit" }}>Escolha a imagem que será exibida no fundo das telas de Autoatendimento.</p>
            
            <Row className="g-4">
                {BACKGROUND_OPTIONS.map(bg => (
                    <Col md={3} sm={6} key={bg.id}>
                        <div 
                            className="overflow-hidden position-relative cursor-pointer shadow-sm animate-all"
                            style={{ 
                                transition: 'all 0.2s', 
                                opacity: selectedBg === bg.id ? 1 : 0.8,
                                borderRadius: "12px",
                                border: selectedBg === bg.id ? "3px solid #e2661c" : "3px solid transparent",
                                boxShadow: selectedBg === bg.id ? "0 8px 24px rgba(226, 102, 28, 0.20)" : "var(--shadow-premium-subtle)"
                            }}
                            onClick={() => handleSelectBg(bg.id)}
                        >
                            <img src={bg.src} alt={bg.label} className="img-fluid w-100" style={{ height: '300px', objectFit: 'cover' }} />
                            
                            <div className="position-absolute bottom-0 w-100 p-2" style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)' }}>
                                <div className="text-white text-center fw-bold font-size-13" style={{ fontFamily: "Outfit" }}>{bg.label}</div>
                            </div>

                            {selectedBg === bg.id && (
                                <div 
                                    className="position-absolute top-0 end-0 m-2 rounded-circle d-flex align-items-center justify-content-center" 
                                    style={{ 
                                        width: '30px', 
                                        height: '30px',
                                        backgroundColor: '#e2661c',
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.2)"
                                    }}
                                >
                                    <i className="mdi mdi-check text-white"></i>
                                </div>
                            )}
                        </div>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default MediaBackgrounds;
